import { render, staticRenderFns } from "./ModalSemanas.vue?vue&type=template&id=2c1bdd0c&"
import script from "./ModalSemanas.vue?vue&type=script&lang=js&"
export * from "./ModalSemanas.vue?vue&type=script&lang=js&"
import style0 from "./ModalSemanas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports